<template>
  <crud-form
    v-model="payload"
    :request-class="requestClass"
    :page-title="setPageTitle"
    :navigate-back-route="navigateBackRoute"
    :navigate-page-after-save="navigateBackRoute"
    :total-group="1"
  >
    <template slot="group-1">
      <form-group title="Informações do segmento">
        <v-row>
          <v-col cols="6">
            <input-text
              id="input:nomSegmento"
              v-model="payload.nomSegmento"
              label="Nome do segmento"
              :rules="[requiredRule]"
              required
              outlined
            />
          </v-col>
          <v-col cols="6">
            <input-select
              id="input:segmentoPai"
              v-model="payload.segmentoPai"
              label="Segmento pai"
              :items="segmentoPaiOptions"
              :disabled="!segmentoPaiOptions.length"
              clearable
              outlined
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import RequestSelectMixin from '@/app/arch/mixins/RequestSelectMixin';
import SegmentoRequest from './SegmentoRequest';

export default {
  name: 'SegmentoForm',
  components: { CrudForm, FormGroup },
  mixins: [RulesMixin, RequestSelectMixin],
  data: () => ({
    requestClass: SegmentoRequest,
    navigateBackRoute: 'segmento.list',
    payload: {
      nomSegmento: '',
      segmentoPai: '',
    },
    segmentoPaiOptions: [],
    segmentoPaiMessageError: 'Falha ao buscar segmentos!',
  }),
  computed: {
    getId() {
      return this.$route.params.id;
    },
    setPageTitle() {
      return this.getId ? 'Editar segmento' : 'Adicionar segmento';
    },
  },
  created() {
    this.getSegmentos();
  },
  methods: {
    getSegmentos() {
      this.serviceCall(
        this.requestClass.list(
          this.makeParams(),
        ),
        this.setDataOptions(
          'segmentoPaiOptions',
          'nomSegmento',
        ),
        this.segmentoPaiMessageError,
      );
    },
  },
};
</script>
